// extracted by mini-css-extract-plugin
module.exports = {"icon-container":"CardIcon_icon-container__Aghee","card__icon":"CardIcon_card__icon__19pt_"};